import React, { useEffect, useState } from 'react';
import { useQuery } from '~~utils/CommonUtils';
import { Div, LeftBox, RightBox, ContentBox } from './Styles';
import loginPic from './assets/loginPic.jpg';
import logo from './assets/logo.png';
import SignInForm from './SignInForm';
import SignUpForm from './SignUpForm';
import CompleteSignUp from './CompleteSignUp';
import ForgetPasswordForm from './ForgetPasswordForm';
import ResetPasswordForm from './ResetPasswordForm';
import { STATUS, CONTENT } from './LoginConsts';
import { useRootState } from '../../useRoot';

const renderByStatus = (status, platform = '', handleForgetPassword) => {
  switch (status) {
    case STATUS.SIGN_IN:
      return <SignInForm handleForgetPassword={handleForgetPassword} />;
    case STATUS.SIGN_UP:
      return <SignUpForm />;
    case STATUS.COMPLETE_SIGN_UP:
      return <CompleteSignUp platform={platform} />;
    case STATUS.FORGET_PASSWORD:
      return <ForgetPasswordForm />;
    case STATUS.RESET_PASSWORD:
      return <ResetPasswordForm />;
    default:
      throw new Error('Unknown status');
  }
};

const Login = () => {
  const query = useQuery();
  const doneURL = query.get('done_url');

  const { loginInfo } = useRootState();
  const [status, setStatus] = useState(STATUS.SIGN_IN);
  const platform = query.get('platform');

  useEffect(() => {
    if (!loginInfo.isLogin) {
      return;
    }

    const targetURL = doneURL ? doneURL : process.env.REACT_APP_MAINPAGE_URL;
    window.location.href = targetURL;
    window.location.replace(targetURL);
  }, [doneURL, loginInfo.isLogin]);

  useEffect(() => {
    switch (query.get('type')) {
      case 'register': {
        setStatus(STATUS.SIGN_UP);
        break;
      }
      case 'completeSignUp': {
        setStatus(STATUS.COMPLETE_SIGN_UP);
        break;
      }
      case 'forgetPassword': {
        setStatus(STATUS.FORGET_PASSWORD);
        break;
      }
      case 'resetPassword': {
        setStatus(STATUS.RESET_PASSWORD);
        break;
      }
      default: {
        break;
      }
    }
  }, [query]);

  function handleSwitchStatus() {
    if (status === STATUS.SIGN_IN) {
      query.set({ type: 'register' });
    } else {
      setStatus(STATUS.SIGN_IN);
      query.delete('type');
    }
  }

  function handleForgetPassword() {
    query.set({ type: 'forgetPassword' });
  }

  return (
    <Div>
      <LeftBox>
        <div className="wrapper">
          <img src={loginPic} alt="bc" />
          <div className="color-mask">
            <ContentBox>
              <div className="title">{CONTENT[status].title}</div>
              <img src={logo} alt="Rebas" />
              <div className="msg-box">
                <div className="msg">{CONTENT[status].message}</div>
                <div className="msg-link" onClick={handleSwitchStatus}>
                  {CONTENT[status].link}
                </div>
              </div>
            </ContentBox>
          </div>
        </div>
      </LeftBox>
      <RightBox>{renderByStatus(status, platform, handleForgetPassword)}</RightBox>
    </Div>
  );
};

export default Login;
